export const textStyles = {
  hx: {
    sizeMultiplier: 2.4,
    weight: 700,
    size: 72,
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  h0: {
    sizeMultiplier: 2,
    weight: 700,
    size: 40,
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  h1: {
    sizeMultiplier: 2.4,
    weight: 700,
    size: 32,
    lineHeight: 1.25,
    letterSpacing: 0,
  },
  h2: {
    sizeMultiplier: 2,
    weight: 600,
    size: 24,
    lineHeight: 1,
    letterSpacing: 0,
  },
  h3: {
    sizeMultiplier: 1.4,
    weight: 600,
    size: 20,
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  h4: {
    sizeMultiplier: 1,
    weight: 600,
    size: 18,
    lineHeight: 1,
    letterSpacing: 0,
  },
  h5: {
    sizeMultiplier: 0.8,
    weight: 600,
    size: 16,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  h6: {
    sizeMultiplier: 0.8,
    weight: 700,
    size: 16,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  p1: {
    sizeMultiplier: 1,
    weight: 400,
    size: 16,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  p2: {
    sizeMultiplier: 0.8,
    weight: 600,
    size: 14,
    lineHeight: 1.7,
    letterSpacing: 0,
  },
  p3: {
    sizeMultiplier: 0.65,
    weight: 400,
    size: 14,
    lineHeight: 1.7,
    letterSpacing: 0,
  },
  p4: {
    sizeMultiplier: 0.44,
    weight: 400,
    size: 12,
    lineHeight: 2,
    letterSpacing: 0,
  },
  p5: {
    sizeMultiplier: 0.44,
    weight: 400,
    size: 10,
    lineHeight: 2.4,
    letterSpacing: 0,
  },
}
